import { render } from "./divedit.vue?vue&type=template&id=50b19c1d&scoped=true&ts=true"
import script from "./divedit.vue?vue&type=script&lang=ts"
export * from "./divedit.vue?vue&type=script&lang=ts"

import "./divedit.vue?vue&type=style&index=0&id=50b19c1d&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b19c1d"]])

export default __exports__